import paymentMethods from "@/helpers/paymentMethods"
export default function() {
    return {
        apiUrl: process.env.VUE_APP_API_URL,
        orders: [],
        showOrderModal: false,
        showCancelModal: false,
        showPayPixModal: false,
        showPayCreditCardModal: false,
        availableInstallments: [],
        installments: null,
        orderDetails: {},
        cancelOrderError: null,
        cancelOrderSuccess: false,
        refundForm: false,
        terms: null,
        showTermsModal: false,
        agencyName: null,
        paymentMethods,
        refundFormData: {
            bankLabel: null,
            bank: null,
            agency: null,
            account: null,
            document: null,
            name: null
        },
        blockAction: false
    }
}
